module.exports = {"validator":{"card_id":{"card_does_not_belong_to_customer_organisation":"Kon de aanvraag niet voltooien omdat de kaart niet tot de huidige gebruiker behoort."}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/form.json
// module id = nFBp
// module chunks = 1